import { Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { ClientsService } from 'src/app/services/clients.service';
import { UserService } from 'src/app/services/user.service';
import { EulaAgreementComponent } from '../eula-agreement/eula-agreement.component';
import { COUNTRY_PHONE_CODE_LIST } from '../../helpers/data';

@Component({
    selector: 'app-create-new-client',
    templateUrl: './create-new-client.component.html',
    styleUrl: './create-new-client.component.scss',
    standalone: false
})
export class CreateNewClientComponent {
	@ViewChild('createYourOwnModal') createYourOwnModal!: TemplateRef<any>;
	@ViewChild('successModal') successModal!: TemplateRef<any>;
	@ViewChild('eulaAgreement') private eulaAgreement!: EulaAgreementComponent;
	@Output() closeSubmittion = new EventEmitter();

	signupForm!: UntypedFormGroup;
	submitted = false;
	eulaChecked = false;
	successMessage = '';
	success = false;
	spinner = false;

	user!: any;
	createYourOwnModalRef: any;
	countryCodeData = COUNTRY_PHONE_CODE_LIST;

	constructor(private router: Router, private clientService: ClientsService, private authService: AuthService, private userService: UserService, private modalService: NgbModal, private formBuilder: UntypedFormBuilder) {}
	
	openModal() {
		this.user = this.authService.currentUserValue;
		
		this.submitted = false;
		this.success = false;

		this.signupForm = this.formBuilder.group({
			name: ['', [Validators.required]],
			first_name: [{ value: this.user.person.first_name, disabled: true  }],
			last_name: [{ value: this.user.person.last_name, disabled: true  }],
			email: [{ value: this.user.email, disabled: true  }],
			phone_country_code: [{ value: this.user.person.phone_country_code, disabled: !!this.user.person.phone_country_code }, Validators.required],
			phone: [{ value: this.user.person.phone, disabled: !!this.user.person.phone }, Validators.required]
		});

		this.createYourOwnModalRef = this.modalService.open(this.createYourOwnModal, { size: 'l', backdrop: 'static', keyboard : false });
	}

	onCheckedDone() {
		this.eulaChecked = !this.eulaChecked;
	}

	viewAgreement() {
		this.eulaAgreement.openModal();
  }

	get f() { return this.signupForm.controls; }

	onSubmit() {
    this.submitted = true;

		if (!this.signupForm.valid) {
			this.spinner = false;
			return;
		}

		const data: any = {
			client: {
				name: this.f['name'].value
			}
		}

		if (this.user.person.phone) {
			data.person = {
        phone_country_code: this.f['phone_country_code'].value,
        phone: this.f['phone'].value
			}
		}

		this.spinner = true;
		this.signupForm.disable();

		this.clientService.createClient(data).subscribe({
			next: (data: any) => {
				this.successMessage = data.message;
				this.submitted = false;
				this.spinner = false;
				this.createYourOwnModalRef.close();
				this.success = true;
				this.modalService.open(this.successModal, { size: 'l', backdrop: 'static', keyboard : false });
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.signupForm.enable();
				this.authService.toastErrorMessage(err.message ? err.message : err, 'Creation Error!');
			}
		});
	}

	closeModalCreation() {
		this.closeSubmittion.emit(this.success);
		this.modalService.dismissAll();
	}

	customSearchFn(term: any, item: any) {
		term = term.toLocaleLowerCase();
    return item.countryName.toLocaleLowerCase().indexOf(term) > -1
	}

	closeModal() {
		this.modalService.dismissAll();
	}
}
